"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M23 2H1v16h9v2H8v2h8v-2h-2v-2h9zm-2 14H3V4h18z"
}), 'DesktopWindowsSharp');